import dynamic from 'next/dynamic';

export { default as Topbar } from './Topbar';
export { default as Sidebar } from './Sidebar';

export const Footer = dynamic(() => import('./Footer'));
